import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import Home from '@/components/home/home'
// 普通用户
import statistical from './statistical.js'
import standingBook from './standingBook.js'
import order from './order.js'
import management from './management.js'
import goods from './goods.js'
import settings from './settings.js'
import district from './district.js'
import lzproduce from "./lzproduce.js";
import farmwork from "./farmwork.js";
import traceEquipment from "./traceEquipment.js"
import szDetection from "./szDetection.js"
import tzFarming from "./tzFarming"
import tzSlaughter from "./tzSlaughter"
// import farmworksy from "./farmworksy.js";
import farmworkcommodity from "./farmworkcommodity.js";
import farmworkreview from "./farmworkreview.js";
import production from "./production.js"
import retrieval from "./retrieval.js"
import enterprise from "./enterprise.js"
// 超管    ...farmworksy,
import user from './user.js'
import role from './role.js'
import fun from './fun.js'
// BDP
import analyze from './analyze.js'
import differentSz from './differentSz'
import assets from './assets'
import retail from './retail'
import repair from './repair'
import quotation from './quotation'

import control from './control'
import analysis from './analysis'
import collect from './collect'
import warning from './warning'
import nodeManage from './nodeManage'
import monitor from './monitor'
import supervise from './supervise'
import traceabiltyInfo from './traceabiltyInfo'
import dataPort from './dataPort'
import compare from './compare'
import platform from './platform.js'
import establishment from './establishment'
import survey from './survey'
import report from './report'
import approach from './approach'
import standingBookCq from './standingBookCq'
import DataEnterprise from './DataEnterprise'
import DataReport from './DataReport'
import FtReport from './FtReport'
import enterpriseFt from './enterpriseFt'
import reportGwzx from './reportGwzx'
import reportCs from './reportCs'
import reportFt from './reportFt'
import enterpriseCy from './enterpriseCy' // 丰台餐饮数据上报企业管理
import manageCy from './manageCy' // 监督企业管理
import superviseJc from './superviseJc' // 监督检查
import notice from './notice' // cpscjd通知公告
import monitorCy from './monitorCy' // 企业监控
import noticeQy from './noticeQy' // 企业通知公告
import trainQy from './trainQy' // 企业培训
import administration from './administration' // 合并xxst  台账、供应商管理、商品
import keepRecord from './keepRecord' // 超管商品、供应商
import inspection from './inspection' // 督查
import enterpriseShop from './enterpriseShop' // 丰台4s店数据上报
import reportShop from './reportShop' 
import reportCy from './reportCy' // 丰台餐饮数据上报
import nodeAccount from './nodeAccount' // 运维2 企业账号查询
import nuclein from './nuclein' // 核酸检测上报
import enterpriseLs from './enterpriseLs' // 丰台零售填报监管
import reportLs from './reportLs' // 企业零售上报
import reportQt from './reportQt' // 企业其他重点企业数据上报
import enterpriseQt from './enterpriseQt' // 其他重点企业数据上报
import monitorQuery from './monitorQuery' // 量价监测查询
import monitorReport from './monitorReport' // 量价监测报告
import tracing from './tracing' // cpjw追溯情况统计
import gateManage from './gateManage' // fagcy档口管理
import infoArticle from './infoArticle' // 超管咨询
import salesData from './salesData'; // ftsc swj_ft 合并
import dataReportMerge from './dataReportMerge'; // ftsc swj_ft 合并
import necessaries from './necessaries'; // ftsc swj_ft 合并
import dataScreen from './dataScreen';
import supervisionQy from './supervisionQy';  // 企业督导
import systemFile from './systemFile';  // 制度文件
import feedback from './feedback'; // 督导反馈
import taskAnalysis from './taskAnalysis.js'; // cpwengshuai 首页 任务完成情况分析
import programmeBb from './programmeBb.js'; // cpwengshuai  包保方案管理
import noticeBb from './noticeBb.js'; // cpwengshuai  通知公告
import cadreBb from './cadreBb.js'; // cpwengshuai  包保干部管理
import subjectBb from './subjectBb.js'; // cpwengshuai  包保主体管理
import systemBb from './systemBb.js'; // cpwengshuai 制度文件管理
import ledgerScQy from './ledgerScQy.js'; // 生产企业台账
import ledgerScJg from './ledgerScJg.js'; // cpsck 生产科 台帐
import dailyInspect from './dailyInspect.js'; // 日常检查
import weighing from './weighing.js'; // 过磅称重
Vue.use(Router);
//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      children:[
        ...statistical,
        ...standingBook,
        ...order,
        ...district,
        ...management,
        ...farmwork,
        ...lzproduce,

        ...farmworkcommodity,
        ...farmworkreview,
        ...goods,
        ...settings,
        ...user,
        ...role,
        ...fun,
        ...analyze,
        ...differentSz,
        ...assets,
        ...production,
        ...traceEquipment,
        ...szDetection,
        ...tzFarming,
        ...tzSlaughter,
        ...retail,
        ...repair,
        ...quotation,
        ...control,
        ...analysis,
        ...collect,
        ...warning,
        ...nodeManage,
        ...retrieval,
        ...enterprise,
        ...monitor,
        ...supervise,
        ...traceabiltyInfo,
        ...dataPort,
        ...compare,
        ...platform,
        ...establishment,
        ...survey,
        ...report,
        ...approach,
        ...standingBookCq, // 配餐台账
        ...FtReport,
        ...DataEnterprise,
        ...DataReport,
        ...enterpriseFt,
        ...reportGwzx,
        ...reportCs,
        ...reportFt,
        ...enterpriseCy,
        ...manageCy,
        ...superviseJc,
        ...notice,
        ...monitorCy,
        ...noticeQy,
        ...trainQy,
        ...administration,
        ...keepRecord,
        ...inspection,
        ...enterpriseShop,
        ...reportShop,
        ...reportCy,
        ...nodeAccount,
        ...nuclein,
        ...enterpriseLs,
        ...reportLs,
        ...reportQt,
        ...enterpriseQt,
        ...monitorQuery,
        ...monitorReport,
        ...tracing,
        ...gateManage,
        ...infoArticle,
        ...salesData,
        ...dataReportMerge,
        ...necessaries,
        ...dataScreen,
        ...supervisionQy,
        ...systemFile,
        ...feedback,
        ...taskAnalysis,
        ...programmeBb,
        ...noticeBb,
        ...cadreBb,
        ...subjectBb,
        ...systemBb,
        ...ledgerScQy,
        ...ledgerScJg,
        ...dailyInspect,
        ...weighing,
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js